import React from 'react'
import {Link} from 'react-router-dom'
import './style.css'

const PageTitle = (props) => {
    const style = props.backgroundImage ? {
        backgroundImage: `url(${props.backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    } : undefined;
    return(
        <>
            {!props.hideText ? (
                <div className="wpo-breadcumb-area" style={style}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="wpo-breadcumb-wrap">
                                    <h2>{props.pageTitle}</h2>
                                    <ul>
                                        <li><Link to="/home">Home</Link></li>
                                        <li><span>{props.pagesub}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                props.backgroundImage ? (
                     <div className="wpo-breadcumb-area" style={style}></div>
                ) : null
            )}
        </>
    )
}

export default PageTitle;